const money = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  maximumFractionDigits: 0,
});
const moneyCents = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const kilos = new Intl.NumberFormat('es-AR', { maximumFractionDigits: 3 });
const longDate = new Intl.DateTimeFormat('es-AR', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
});
const shortDate = new Intl.DateTimeFormat('es-AR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});
const dateTime = new Intl.DateTimeFormat('es-AR', {
  day: '2-digit',
  month: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

/** Centavos a pesos, sin redondear: 128450000 → "$ 1.284.500"; 728355 → "$ 7.283,55" */
export const formatMoney = (cents: number): string => (cents % 100 === 0 ? money : moneyCents).format(cents / 100);
/** Gramos a kilos, al gramo (sin redondear): 486000 → "486 kg", 590 → "0,59 kg" */
export const formatKilos = (grams: number): string => `${kilos.format(grams / 1000)} kg`;
export const formatLongDate = (d: Date): string => longDate.format(d);
export const formatDate = (iso: string): string => shortDate.format(new Date(iso.length === 10 ? `${iso}T12:00:00` : iso));
const usdFmt = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'USD', maximumFractionDigits: 2, minimumFractionDigits: 0 });
/** Centavos de dólar: 8000 → "US$ 80" (lo que se le cobra al cliente por BifeAI). */
export const formatUsd = (cents: number): string => usdFmt.format(cents / 100);
export const formatDateTime = (iso: string): string => dateTime.format(new Date(iso));

export function timeAgo(iso: string): string {
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return 'recién';
  if (diff < 3600) return `hace ${Math.floor(diff / 60)} min`;
  if (diff < 86_400) return `hace ${Math.floor(diff / 3600)} h`;
  const days = Math.floor(diff / 86_400);
  return days === 1 ? 'ayer' : `hace ${days} días`;
}

export function firstName(name: string): string {
  return name.trim().split(/\s+/)[0] ?? name;
}

export function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
